import { render, staticRenderFns } from "./Register_Persona.vue?vue&type=template&id=59e07907"
import script from "./Register_Persona.vue?vue&type=script&lang=js"
export * from "./Register_Persona.vue?vue&type=script&lang=js"
import style0 from "./Register_Persona.vue?vue&type=style&index=0&id=59e07907&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports